<template>
  <div>
    <p class="end-node">结束节点</p>
  </div>
</template>

<script>
import { getMessageListForNode } from '@/api/customer.js'
export default {
  name: '',
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
    // 传值到父组件
    update() {
      // 传值到父组件
      let choose = {}
      choose.nodeType = 'endNode'
      this.$emit('change', choose)
    }
  },
  watch: {
  },
  created() {
    this.update()
  }
}
</script>

<style scoped>
  .end-node{
    text-align: left;
    padding-left: 20px;
    color: #999;
    font-weight: bold;
    font-size: 20px;
  }
</style>
